import React from 'react';
import { Drawer, Icon } from 'antd';

const CloseIcon = <Icon type="close" className="text-gray-600" />;

const SlidePanel = ({
  title,
  children,
  footer,
  width = 440,
  placement = 'right',
  closable = true,
  maskClosable = true,
  className = '',
  ...rest
}) => (
  <Drawer
    {...rest}
    placement={placement}
    width={width}
    title={<span className="text-ts-xl font-fig-semibold text-gray-900">{title}</span>}
    closable={closable}
    closeIcon={CloseIcon}
    maskClosable={maskClosable}
    className={`ds-slide-panel ${className}`.trim()}
    bodyStyle={{ paddingBottom: 24 }}
  >
    {children}
    {footer ? <div className="mt-ds-6 border-t border-gray-300 pt-ds-4">{footer}</div> : null}
  </Drawer>
);

export default SlidePanel;
